import { useRef } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useTracker } from '../tracking/useTracker';
import { StyledGoogleLogoPlaceholder, StyledGoogleOAuthButton, StyledGoogleOAuthContainer, StyledGoogleOAuthFallbackButton, StyledGoogleOAuthFallbackButtonContainer, StyledGoogleOAuthFallbackButtonContent, StyledGoogleOAuthFallbackButtonIcon, StyledGoogleOAuthFallbackButtonText, StyledGoogleOAuthDiv } from './GoogleOAuthButton.styles.ts';
import { useGoogleIdentityServices } from './useGoogleIdentityServices';
import { useGoogleLoginNonce } from './useGoogleLoginNonce';
import { useLoadGoogleIdentityServices } from './useLoadGoogleIdentityServices';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const GoogleOAuthButton = () => {
  const googleButtonRef = useRef(null);
  const {
    googleSignInNonce,
    didNonceRequestFail
  } = useGoogleLoginNonce();
  const Tracker = useTracker();
  const {
    APP_DIMS
  } = useResponsiveness();
  const onAuthenticationFailed = failure => Tracker.signupInteraction(`google-oauth-exception-${failure.reason}`);
  const {
    isLoading,
    isLoaded
  } = useLoadGoogleIdentityServices({
    onAuthenticationFailed
  });
  const isGoogleLibraryLoaded = !isLoading || isLoaded;
  useGoogleIdentityServices({
    googleButtonRef,
    libraryHasLoaded: isGoogleLibraryLoaded,
    googleSignInNonce
  });
  if (didNonceRequestFail) {
    return /*#__PURE__*/_jsx(StyledGoogleOAuthFallbackButtonContainer, {
      children: /*#__PURE__*/_jsx(StyledGoogleOAuthFallbackButton, {
        "data-test-id": "oauth-button-google-fallback",
        disabled: true,
        use: "primary",
        children: /*#__PURE__*/_jsxs(StyledGoogleOAuthFallbackButtonContent, {
          children: [/*#__PURE__*/_jsx(StyledGoogleOAuthFallbackButtonIcon, {
            name: "socialGoogle",
            size: APP_DIMS.button.iconHeight
          }), /*#__PURE__*/_jsx(StyledGoogleOAuthFallbackButtonText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'views.LANDING_PAGE.googleSignup'
            })
          })]
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(StyledGoogleOAuthContainer, {
    "data-test-id": "oauth-button-google",
    id: "google-oauth-container",
    children: /*#__PURE__*/_jsx(StyledGoogleOAuthDiv, {
      children: isGoogleLibraryLoaded ? /*#__PURE__*/_jsx(StyledGoogleOAuthButton, {
        className: "GoogleIdentityServicesButton",
        id: "g_id_onload",
        ref: googleButtonRef
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledGoogleLogoPlaceholder, {}), /*#__PURE__*/_jsx(UILoadingSpinner, {
          layout: "centered",
          size: "sm",
          style: {
            margin: 'auto'
          }
        }), /*#__PURE__*/_jsx(StyledGoogleLogoPlaceholder, {})]
      })
    })
  });
};